export default __webpack_public_path__ + "static/media/capable.39bc0a03.png";